enum PlayerError {
  SOURCE_NOT_FOUND = 'source_not_found',
  GEO_RESTRICTION = 'geo_restriction',
  UNSUPPORTED_DEVICE = 'unsupported_device',
  DRM_SETUP_FAILED = 'drm_setup_failed',
}

export enum PlayerErrorCode {
  MEDIA_ERR_DECODE = 3,
  MEDIA_ERR_SRC_NOT_SUPPORTED = 4,
  MEDIA_ERR_ENCRYPTED = 5,
}

export default PlayerError;
